import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';

export function ApprovalActionPlaceholder({ pulse = true }: { pulse?: boolean }) {
  return (
    <Button variant="contained" color="primary" disabled sx={{ minWidth: 165 }} data-testid="approval-action-placeholder">
      <Skeleton variant="text" width="85%" animation={pulse ? 'pulse' : false} />
    </Button>
  );
}
